// Shared constant for the CC OAuth callback URL path component (P-047
// remediation, 2026-05-27).
//
// **RFC 6749 §3.1.2 forbids fragment identifiers in OAuth redirect URIs**
// ("The endpoint URI MUST NOT include a fragment component"). Constant
// Contact's developer portal enforces this — the original P-047 LOCKED
// form `${BASE_URL}/#/auth/cc-callback` was rejected at registration
// with `Api validation failed: redirect_uris: "redirect_uris" must not
// contain a fragment identifier.`
//
// So our SPA registers the **path** form (this constant) with CC. When
// CC redirects the browser back, the URL is `${BASE_URL}/auth/cc-callback?code=...&state=...`.
// Firebase Hosting's SPA rewrite (`/** → /index.html`, per P-002) serves
// the SPA at that path. A pre-mount shim in `src/app/cc-callback-redirect-shim.ts`
// detects the path on boot and `history.replaceState`s the URL into the
// hash form (`/#/auth/cc-callback?code=...&state=...`) so the hash router
// (D-085) routes to `<CCCallbackScreen />` exactly as if the user had
// navigated to the hash form directly. No page reload, no flicker.
//
// **Why a shared constant at 2 consumers** (below the project's 3-use
// threshold per D-067/D-072/D-077/D-094): the divergence cost is high
// (silent OAuth breakage in production if either side drifts) and the
// abstraction cost is zero (one string). Extracting now beats the
// alternative of a `// MUST stay in sync with ...` comment at two sites.

export const CC_CALLBACK_PATH = '/auth/cc-callback'
